var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortalOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-730 -333)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(730 333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.667,3H4.833A1.839,1.839,0,0,0,3,4.833V17.667A1.839,1.839,0,0,0,4.833,19.5H17.667A1.839,1.839,0,0,0,19.5,17.667V4.833A1.839,1.839,0,0,0,17.667,3ZM4.833,17.667V4.833h5.5V17.667Zm12.833,0h-5.5V11.25h5.5Zm0-8.25h-5.5V4.833h5.5Z",
    transform: "translate(727.75 330.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortalOn);
export default __webpack_public_path__ + "static/media/icon_portal_on.2a098be8f4e17c8f3f3b98651adb4311.svg";
export { ForwardRef as ReactComponent };